<template>
<div class="header">
  <div class="header-top flex-row-center container" wzades="顶部菜单" aria-label="顶部菜单">
    <a :href="titleHref" tabindex="0">
      <img :src="require('../assets/imgs/gdzw-logo.png')" alt="点击访问广东政务服务网" title="点击访问广东政务服务网">
    </a>
    <div class="header-top-right" v-if="isOpenAging=='1'">
      <button title="长者模式" class="older-mode" @click="slh()">长者模式</button>
      <button title="无障碍阅读" class="accessible-reading" @click="wza()">无障碍阅读</button>
    </div>
  </div>
  <div class="banner-img">
    <img :src="require('../assets/imgs/banner.png')">
    <div class="banner-container">
      <p class="platform-name">全国一体化政务服务平台</p>
      <p class="title">湛江市跨域通办专区</p>
    </div>
  </div>
</div>
</template>

<script>
const mhHost = "http://www.gdzwfw.gov.cn";
export default {
  data() {
    return {
      titleHref: `${mhHost}/portal/index`,
      isOpenAging: "", //是否开启长者模式
    }
  },
  methods: {
    // 增加老年模式
    slh() {
      slhInstance.init(); // slhInstance 为全局变量 
    },
    // 无障碍
    wza() {
      cnillWzaInstance.init(); // cnillWzaInstance为全局变量
    },
  },
  created() {
    this.isOpenAging = sessionStorage.getItem('AGING_KEY') || ''
  }
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  position: relative;

  .header-top {
    position: relative;
    height: 80px;

    img {
      width: 182px;
      height: 40px;
    }

    .header-top-right {
      flex-grow: 1;
      text-align: right;
    }
  }

  .banner-img {
    position: relative;
    min-width: 1200px;
    height: 385px;
    text-align: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .banner-container {
    position: absolute;
    top: 80px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 1000px;
  }

  .platform-name {
    line-height: 40px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    border: 1px solid rgba(227, 236, 243, 0.5);
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 10px;
    width: 380px;
    margin: 0 auto;
  }

  .title {
    font-size: 70px;
    line-height: 98px;
    line-height: 84px;
    letter-spacing: 4px;
    color: #FFFFFF;
    text-align: center;
    margin-top: 40px;
  }
}
</style>
